<template>
  <mtdm-pullrefresh v-model="isLoading" @refresh="onRefresh">
    <div class="detail-header">
      <mtdm-navigation-bar :title="$getText('wenshu_menu_sub_outgoing_record', '下属外发记录')" left-icon=""
                           fixed :right-text="$getText('wenshu_web_settings', '设置')" :left-text="$getText('wenshu_mobile_filter', '筛选')"
                           @click-left="screenShow = true"
                             @click-right="userSettingShow = true"></mtdm-navigation-bar>
    </div>
    <div class="record-container">
      <mtdm-popup v-model="screenShow" position="top">
        <div style="height: 8px;"></div>
        <div style="padding: 16px">
          <div class="screen-title">
            <mtd-form ref="screenForm" label-position="top">
              <mtd-row>
                <mtd-col :span="24">
                  <mtd-form-item label="MISID">
                    <mtd-input style="width: 100%" v-model="search_form.creator" placeholder="MISID"/>
                  </mtd-form-item>
                </mtd-col>
              </mtd-row>
              <mtd-row>
                <mtd-col :span="24">
                  <mtd-form-item :label="text_data.file_name">
                    <mtd-input style="width: 100%" v-model="search_form.fileName" :placeholder="text_data.please_input_file_name"/>
                  </mtd-form-item>
                </mtd-col>
              </mtd-row>
              <mtd-row :gutter="8">
                <mtd-col :span="12">
                  <mtdm-button type="secondary" style="width: 100%" size="middle" @click="reset_search_form">
                    {{ $getText('wenshu_mobile_reset', '重置') }}
                  </mtdm-button>
                </mtd-col>
                <mtd-col :span="12">
                  <mtdm-button type="primary" style="width: 100%" size="middle" @click="list_table_data">
                    {{ $getText('ws_mobile_confirm', '确定') }}
                  </mtdm-button>
                </mtd-col>
              </mtd-row>
            </mtd-form>
          </div>
        </div>
      </mtdm-popup>
      <div class="card-container">
        <div class="card-item" v-for="(item,index) in file_out_apply_list">
          <div class="card-header" @click="expand(index)">
            <div class="header-text">
              <div class="card-icon" v-if="item.isClick">
                <mtd-icon name='up-thick'></mtd-icon>
              </div>
              <div class="card-icon" v-else>
                <mtd-icon name='down-thick'></mtd-icon>
              </div>
              <div class="record-id">{{ item.id }}</div>
              <div class="file-names">{{ item.fileNames | fileNamesFilter }}</div>
              <div class="record-status">
                <mtd-tag theme="blue" type="pure" v-if="item.status === 0" class="approving">{{ $getText('ws_mobile_status_approving', '审批中') }}</mtd-tag>
                <mtd-tag theme="green" type="pure" v-if="item.status === 1" class="pass">{{ $getText('ws_mobile_status_approved', '已通过') }}</mtd-tag>
                <mtd-tag theme="red" type="pure" v-if="item.status === 2" class="rejected">{{ $getText('ws_mobile_status_rejected', '已驳回') }}</mtd-tag>
              </div>
            </div>
            <div class="header-time">
              <span>{{ $getText('ws_mobile_apply_time', '申请时间：') }}{{ item.createTime | dateFormat }} </span>
              <span style="float: right">MIS：{{ item.creator }} </span>
            </div>
          </div>
          <div class="record-detail" v-if="item.isClick">
            <mtd-form>
              <mtd-form-item :label="$getText('ws_mobile_file_count', '文件数量')" :label-width="100">
                {{ $getText('ws_mobile_file_count_unit', {count: item.fileNum}, '{count}个文件') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_process', '外发流程')" :label-width="100">
                {{ item.strategyName || $getText('ws_mobile_no_approval_required', '免审批') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_reason', '外发原因')" :label-width="100">
                {{ item.reason || $getText('ws_mobile_none', '无') }}
              </mtd-form-item>
              <mtd-form-item :label="$getText('ws_mobile_send_out_email', '外发邮箱')" :label-width="100">
                {{ item.emails || $getText('ws_mobile_none', '无') }}
              </mtd-form-item>
            </mtd-form>
          </div>
          <div class="approval-btn" @click.stop="check_process(item)">
            <mtd-button style="padding-left: 0" type="text-primary" :disabled="item.bpmAddress == null || item.bpmAddress === ''">
              {{ $getText('ws_mobile_approval_progress', '审批进度') }}
            </mtd-button>
            <div style="float: right;font-size: 20px">
              <mtd-icon name='right-thick'></mtd-icon>
            </div>
          </div>
          <div class="operation-container" @click.stop>
            <mtd-row :gutter="8">
              <mtd-col :span="12">
                <mtdm-button type="secondary" size="small" style="width: 100%" @click="copy(item)">
                  {{ $getText('ws_mobile_copy_share_link', '复制链接') }}
                </mtdm-button>
              </mtd-col>
              <mtd-col :span="12">
                <mtdm-button type="secondary" size="small" style="width: 100%" @click="terminate_file_out(item.id)"
                             :disabled="item.outOfDate || item.isTerminated || item.status !== 1">
                  <span v-if="item.isTerminated">{{ $getText('wenshu_web_forwarding_prohibited', '已禁止外发') }}</span>
                  <span v-else>{{ $getText('wenshu_web_prohibit_forwarding', '禁止外发') }}</span>
                </mtdm-button>
              </mtd-col>
            </mtd-row>
          </div>
        </div>
      </div>
      <div style="width: 100%;"
           v-if="file_out_apply_list.length !== search_form.total">
        <mtdm-button type="secondary" width="full" size="tiny" @click="loadMore"
                     style="color: rgba(0, 0, 0, 0.24);" :loading="loading">
          {{ $getText('ws_mobile_load_more', '点击加载更多') }}
        </mtdm-button>
      </div>
      <mtdm-popup v-model="userSettingShow" position="top" :title="$getText('wenshu_web_settings', '设置')">
        <div class="slide-content">
          <div class="content-main">
            <mtd-form ref="message_setting_form" :model="message_setting_data">
              <mtd-form-item :label="$getText('wenshu_web_no_approval_cc_notification', '免审批抄送通知:')" :label-width="120">
                <mtd-switch v-model="message_setting_data.message_notice_switch" size="small"
                            style="top: 6px;margin-right: 5px;"/>
              </mtd-form-item>
              <mtd-form-item :label="$getText('wenshu_web_forwarding_report_audit_report_cycle', '外发报备审计报告周期:')" :label-width="160">
                <mtd-select type="secondary" v-model="message_setting_data.report_send_cycle" style="width: 100px;">
                  <mtd-option value="DAY" :label="$getText('wenshu_mobile_one_day', '一天')"/>
                  <mtd-option value="WEEK" :label="$getText('wenshu_mobile_one_week', '一周')"/>
                  <mtd-option value="MONTH" :label="$getText('wenshu_mobile_one_month', '一月')"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-form>
            <mtd-row :gutter="8" style="width: 100%;">
              <mtd-col :span="12">
                <mtdm-button type="secondary" style="width: 100%" size="middle" @click="userSettingShow = false">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtdm-button>
              </mtd-col>
              <mtd-col :span="12">
                <mtdm-button type="primary" style="width: 100%" size="middle" @click="submit_message_setting">{{ $getText('wenshu_mobile_submit', '提交') }}</mtdm-button>
              </mtd-col>
            </mtd-row>
          </div>
        </div>
      </mtdm-popup>
    </div>
  </mtdm-pullrefresh>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "mobile_file_outer_subordinate_out_list",
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error', '最长有效期为30天，请输入1-30以内的数字')));
      }
      if (value < 1 || value > 30) {
        return callback(new Error(this.$getText('ws_mobile_validity_range_error', '最长有效期为30天，请输入1-30以内的数字')));
      }
      return callback();
    }
    return {
      text_data: {
        file_name: '文件名称',
        please_input_file_name: '请输入文件名称',
      },
      isLoading: false,

      screenShow: false,

      userSettingShow: false,

      file_out_apply_list: [],
      copyMessage: '',
      search_form: {
        creator: null,
        fileName: null,
        currentPage: 1,
        limit: 10,
        total: 0,
      },
      loading: false,
      message_setting_data: {
        message_notice_switch: true,
        report_send_cycle: 'DAY'
      },
    }
  },
  filters: {
    fileNamesFilter(fileNames) {
      return fileNames.join(",");
    },
    dateFormat(date) {
      return moment(date)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 修改标题
    document.title = this.$getText('ws_mobile_application_history', '申请历史');

    this.text_data.file_name = this.$getText('ws_mobile_file_name', '文件名称');
    this.text_data.please_input_file_name = this.$getText('wenshu_mobile_please_enter_file_name', '请输入文件名称');

    let query_params = this.$route.query;
    if (query_params) {
      let {creator} = query_params;
      if (creator && creator !== '') {
        this.search_form.creator = creator;
      }
    }
    this.select_record_list();
    this.load_superior_setting();
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'querySubordinateFileOutRecordList',
      'querySuperiorSetting',
      'submitSuperiorSetting',
      'terminateFileOutByOthers',
    ]),
    onRefresh() {
      this.isLoading = true;
      this.select_record_list();
    },
    copy(item, e) {
      if (e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
      }
      let vm = this;
      let message = vm.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + item.downloadUrl + '\n' + this.$getText('ws_mobile_file_share_password_text', '文件分享密码：') + item.downloadPassword;
      vm.$copyText(message).then(function (_e) {
        vm.$mtdm.toast({
          message: vm.$getText('ws_mobile_copy_success', '复制成功'),
          icon: 'mtdmicon-success-circle',
          duration: 2000
        });
      }, function (_e) {
        vm.$mtdm.toast({
          message: vm.$getText('ws_mobile_copy_failed', '复制失败'),
          icon: 'mtdmicon-error-circle',
          duration: 2000
        });
      });
    },
    loadMore() {
      this.loading = true;
      this.search_form.currentPage += 1;
      this.querySubordinateFileOutRecordList(this.search_form).then(res => {
        let temp = res.data.items;
        for (let i = 0; i < temp.length; i++) {
          temp[i].isClick = false;
        }
        this.file_out_apply_list = this.file_out_apply_list.concat(temp);
      }).finally(() => {
        this.loading = false;
      });
    },
    expand(index) {
      let flag = this.file_out_apply_list[index].isClick;
      this.$set(this.file_out_apply_list[index], 'isClick', !flag);
    },
    select_record_list() {
      this.querySubordinateFileOutRecordList(this.search_form).then(res => {
        this.file_out_apply_list = res.data.items;
        this.search_form.total = res.data.total;
      })
    },
    list_table_data() {
      this.search_form.currentPage = 1;
      this.select_record_list();
      this.screenShow = false;
    },
    check_process(item) {
      if (item.bpmAddress) {
        let url = item.bpmAddress;
        window.open(url);
      }
    },
    terminate_file_out(id) {
      this.terminateFileOutByOthers({id: id}).then(res => {
        if (res.code === 0) {
          this.$mtd.message.success(this.$getText('wenshu_web_module_prohibit_forwarding_success', '禁止外发成功'));
        } else {
          this.$mtd.message.error(res.message);
        }
        this.list_table_data();
      }).catch(err => {
        this.$mtd.message.error(this.$getText('wenshu_web_module_prohibit_forwarding_failed', '禁止外发失败'));
      })
    },
    reset_search_form() {
      this.search_form = {
        keyword: '',
        creator: null,
        fileName: null,
        currentPage: 1,
        limit: 10,
        total: 0,
      }
    },
    load_superior_setting() {
      this.querySuperiorSetting({}).then((res) => {
        let data = res.data;
        if (data) {
          let {messageNoticeSwitch, reportSendCycle} = data;
          this.message_setting_data = {
            message_notice_switch: messageNoticeSwitch,
            report_send_cycle: reportSendCycle
          }
        }
      })
    },
    submit_message_setting() {
      let {message_notice_switch, report_send_cycle} = this.message_setting_data;
      let form_data = {messageNoticeSwitch: message_notice_switch, reportSendCycle: report_send_cycle};
      this.submitSuperiorSetting(form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_web_module_set_submit_success', '设置提交成功'));
        this.userSettingShow = false;
      });
    },
  },
}
</script>

<style scoped>
.pass {
  background-color: rgba(36, 189, 120, 0.16);
  color: rgba(36, 189, 120, 1);
  border-color: rgba(36, 189, 120, 0);
}

.approving {
  background-color: rgba(10, 112, 245, 0.16);
  color: rgba(10, 112, 245, 1);;
  border-color: rgba(10, 112, 245, 0);
}

.rejected {
  background-color: rgba(255, 95, 87, 0.16);
  color: rgba(255, 95, 87, 1);
  border-color: rgba(255, 95, 87, 0);
}

.detail-header {
  background-color: #F5F5F5;
  height: 44px;
  z-index: 3068;
}

.approval-btn {
  border-top: #f7f7f7 1px solid;
  padding: 8px;
}

.search-block {
  padding: 15px 7px;
  height: 52px;
}

.search-btn {
  font-family: PingFang SC, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.60);
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
  padding: 0 10px;
  height: 22px;
}

.record-container {
  min-height: 100vh;
  background-color: #f7f7f7;
}

.card-container {
  padding: 8px;
  overflow-y: auto;
}

.card-item {
  padding: 16px 8px;
  background-color: white;
  margin-bottom: 8px;
  border-radius: 10px;
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);;
}

.header-text {
  display: flex;
  height: 24px;
}

.record-id {
  margin-right: 12px;
}

.file-names {
  /*作为弹性伸缩盒子模型显示*/
  display: -webkit-box;
  /*显示的行数；如果要设置2行加...则设置为2*/
  -webkit-line-clamp: 1;
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
  /*伸缩盒子的子元素排列：从上到下*/
  -webkit-box-orient: vertical;
  width: 65%;
  flex-grow: 1;
}

.record-id, .file-names {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 600;
}

.card-icon {
  font-size: 20px;
  align-items: center;
  line-height: 24px;
  margin-right: 6px;

}

.header-time {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  margin-top: 4px;
  margin-left: 26px;
  margin-bottom: 16px;
}

.record-detail {
  padding-top: 16px;
}

.record-detail .mtd-form-item-label, .out-link .mtd-form-item-label {
  text-align: left;
}

.record-detail .mtd-form-item, .out-link .mtd-form-item {
  margin-bottom: 10px;
}

.slide-content {
  padding: 6px;
  border-radius: 5px;
  background-color: #F5F5F5;
}

.slide-content .content-main {
  background-color: #fff;
  padding: 12px;
}

.slide-footer-bar {
  padding: 12px;
  display: flex;
  width: 100%;
}

.slide-footer-bar .mtdm-button-middle {
  width: 100%;
}
</style>
